import iconSvg from './IconBookmarkUnsaved2.svg';

export const IconBookmarkUnsaved = props => <img src={iconSvg} alt="" {...props} />;
